// Dashboard money/label formatters + status colours (split out of CommercialDashboard.js,
// Jun 2026). Pure functions, no behaviour change. Currencies are NEVER collapsed into one
// number; a "(no currency)" bucket is shown explicitly, never defaulted to NGN.

export const STATUS_COLORS = {
  Forecast: "bg-indigo-100 text-indigo-700 border-indigo-200",
  Invoiced: "bg-amber-100 text-amber-700 border-amber-200",
  Collected: "bg-teal-100 text-teal-700 border-teal-200",
  "Written Off": "bg-red-100 text-red-700 border-red-200",
  Deferred: "bg-slate-100 text-slate-600 border-slate-200",
};

export function fmtCash(val) {
  if (!val || val === 0) return "\u20A60";
  if (val >= 1_000_000_000) return `\u20A6${(val / 1_000_000_000).toFixed(1)}B`;
  if (val >= 1_000_000) return `\u20A6${(val / 1_000_000).toFixed(1)}M`;
  if (val >= 1_000) return `\u20A6${(val / 1_000).toFixed(0)}K`;
  return `\u20A6${val.toLocaleString()}`;
}

export const CCY_SYMBOL = { NGN: "\u20A6", GBP: "\u00A3", USD: "$", EUR: "\u20AC" };

export function fmtAmount(val) {
  if (!val) return "0";
  if (val >= 1e9) return `${(val / 1e9).toFixed(1)}B`;
  if (val >= 1e6) return `${(val / 1e6).toFixed(1)}M`;
  return Math.round(val).toLocaleString();  // exact below 1M so foreign receipts stay precise
}

// Render a per-currency map as e.g. "₦75.0M · £15,000". NEVER collapses currencies
// into one number; a "(no currency)" bucket is shown explicitly, never defaulted to NGN.
export function fmtCcy(byCurrency) {
  if (!byCurrency || Object.keys(byCurrency).length === 0) return "\u2014";
  return Object.entries(byCurrency)
    .map(([c, v]) => (c === "__NO_CURRENCY__" ? `(no currency) ${fmtAmount(v)}` : `${CCY_SYMBOL[c] || c + " "}${fmtAmount(v)}`))
    .join("  \u00B7  ");
}

export const SINGULARS = { entries: "entry", invoices: "invoice", payments: "payment", deals: "deal", "open deals": "open deal", "signed deals": "signed deal", records: "record", milestones: "milestone" };
export function pluralLabel(count, label) {
  return count === 1 ? (SINGULARS[label] || label.replace(/s$/, "")) : label;
}
